import { render, staticRenderFns } from "./SakaniProducts.vue?vue&type=template&id=be539344&scoped=true"
import script from "./SakaniProducts.vue?vue&type=script&lang=js"
export * from "./SakaniProducts.vue?vue&type=script&lang=js"
import style0 from "./SakaniProducts.vue?vue&type=style&index=0&id=be539344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be539344",
  null
  
)

export default component.exports